<template>
  <div class="package-name-background py-1 px-2"><p class="mb-0"><strong>{{ item.label }}</strong> </p></div>
</template>

<script>
export default {
  name: 'PackageItemInfo',
  props: ['item']
}
</script>
